import { ModuleName } from '../interfaces/modules/generic';
import { Video } from '../interfaces/videoInterface';

export const serializeVideosToCep = (videos: Video[]): Video[] => videos.map((video) => ({
  ...video,
  modules: video.modules?.length
    ? video.modules
    : video.videos.length ? [
      {
        data: {
          title: 'Video Interview',
          description: '',
          videos: video.videos.filter((v) => (v.moduleOrigin || 'widget') === 'widget')
        },
        id: 'widget',
        name: ModuleName.WIDGET,
        type: 'widget',
        completed: true
      }
    ] : []
}));
